var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 15.5H1.75C0.921573 15.5 0.25 14.8284 0.25 14V3.5C0.25 2.67157 0.921573 2 1.75 2H3.25V0.5H4.75V2H9.25V0.5H10.75V2H12.25C13.0784 2 13.75 2.67157 13.75 3.5V14C13.75 14.8284 13.0784 15.5 12.25 15.5ZM1.75 6.5V14H12.25V6.5H1.75ZM1.75 3.5V5H12.25V3.5H1.75ZM10.75 12.5H9.25V11H10.75V12.5ZM7.75 12.5H6.25V11H7.75V12.5ZM4.75 12.5H3.25V11H4.75V12.5ZM10.75 9.5H9.25V8H10.75V9.5ZM7.75 9.5H6.25V8H7.75V9.5ZM4.75 9.5H3.25V8H4.75V9.5Z",
    fill: "#1479FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlue);
export default __webpack_public_path__ + "static/media/calendar_blue.35cdba02de925fd60ed4aad428d59a50.svg";
export { ForwardRef as ReactComponent };